<ng-container *ngIf="initialized">
    <div class="grid">


        <div class="col-12">
            <p-panel header="Table Widget with Paging">
                <mvs-widget
                        [widgetData]="tableWidgetData"
                        (onObjectSelect)="onCustomerSelect($event)"

                ></mvs-widget>
            </p-panel>
        </div>

        <div class="col-4" *ngIf="selectedObject">

            <!-- Widgets when object is selected -->
            <mvs-widget
                    [widgetData]="customerWidgetData"
            ></mvs-widget>

<!--            <mvs-widget
                    [widgetData]="contactsWidgetData"
            ></mvs-widget>

            <mvs-widget
                    [widgetData]="personWidgetData"
            ></mvs-widget> -->

        </div>

        <div class="col-8">
        </div>

        <!-- TM-1000001960: Side-Car Widgets showcase — the three self-contained
             Clean-Core side-car display components (read-only, German UI). -->
        <div class="col-12">
            <p-panel header="Side-Car Widgets">
                <div class="flex flex-column gap-4">

                    <!-- #4 External Flat -->
                    <mvs-xx-person-external-flat></mvs-xx-person-external-flat>

                    <!-- #5 External Typed -->
                    <mvs-xx-person-external-typed></mvs-xx-person-external-typed>

                    <!-- #3 Internal Typed -->
                    <mvs-xx-person-data></mvs-xx-person-data>

                </div>
            </p-panel>
        </div>

    </div>
</ng-container>
